import React, { Fragment } from 'react'
import Component from 'react-component-component'
import HamburgerMenu from './HamburgerMenu'
import { HamburgerIcon } from 'stylist'

const MobileMenu = ({ isAuthenticated }) => (
  <Component
    initialState={{ open: false }}
    render={({ state, setState }) => (
      <Fragment>
        <HamburgerIcon
          fill="lightBrandGreen"
          width={15}
          onClick={() => setState({ open: true })}
        />
        <HamburgerMenu
          onClose={() => setState({ open: false })}
          open={state.open}
        >
          <HamburgerMenu.Item href="https://book.focusvision.com">
            Book Project
          </HamburgerMenu.Item>
          {isAuthenticated ? (
            <HamburgerMenu.Item to="/logout">Logout</HamburgerMenu.Item>
          ) : (
            <Fragment>
              <HamburgerMenu.Item to="/login">Sign in</HamburgerMenu.Item>
            </Fragment>
          )}
        </HamburgerMenu>
      </Fragment>
    )}
  />
)

export default MobileMenu



// WEBPACK FOOTER //
// ./src/routes/components/MobileMenu.js